import React from 'react';
import PropTypes from 'prop-types';

const Textarea = (props) => {
  const {
    fieldName,
    values,
    value,
    handleChange,
    rows,
    disabled,
    focused,
    classNames,
    maxLength,
    placeholder,
    onKeyDown = () => {},
  } = props;

  const myValue = value || values[fieldName] || '';
  return (
    <textarea
      className={`form-control ${classNames}`}
      name={fieldName}
      // eslint-disable-next-line
      autoFocus={focused}
      value={myValue}
      placeholder={placeholder}
      onChange={handleChange}
      rows={rows}
      wrap="hard"
      maxLength={maxLength}
      disabled={disabled}
      onKeyDown={onKeyDown}
    />
  );
};

Textarea.propTypes = {
  values: PropTypes.object.isRequired,
  value: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  fieldName: PropTypes.string.isRequired,
  rows: PropTypes.number,
  focused: PropTypes.bool,
  disabled: PropTypes.bool,
  classNames: PropTypes.string,
  maxLength: PropTypes.number,
  placeholder: PropTypes.string,
  onKeyDown: PropTypes.func,
};

Textarea.defaultProps = {
  rows: 2,
  disabled: false,
  focused: false,
  classNames: '',
  maxLength: 1600,
  placeholder: 'Message...',
  value: '',
  onKeyDown: () => {},
};

export default Textarea;
